import { render, staticRenderFns } from "./InfoSnippet.vue?vue&type=template&id=54b0c664&scoped=true&"
import script from "./InfoSnippet.vue?vue&type=script&lang=js&"
export * from "./InfoSnippet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b0c664",
  null
  
)

export default component.exports